import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Form, Button, InputGroup } from 'react-bootstrap';
import { GoogleMap, LoadScriptNext } from "@react-google-maps/api";




const Endereco = ({ crud,  storage, empresa }) => {
  const [endereco, setEndereco] = useState(null);
  const [distancia, setDistancia] = useState(null);
  const [duracao, setDuracao] = useState(null);
  const [posicao, setPosicao] = useState(null);
  const navigate = useNavigate();
  const [mapRef, setMapRef] = useState(null);
  const [marker, setMarker] = useState(null);
  const [disponivel, setDisponivel]=useState(true);
  const { get } = crud;

  const containerStyle = {
    width: '100%',
    height: '400px'
  };

  useEffect(() => {
    if (mapRef) {
      const center = mapRef.getCenter();
      const novoMarcador = new window.google.maps.Marker({
        position: center,
        map: mapRef,
        draggable: false,
        title: 'Posição central do mapa',
      });
      setMarker(novoMarcador);
    }
  }, [mapRef]);

  useEffect(() => {
    if (mapRef && marker) {
      const listener = mapRef.addListener('center_changed', () => {
        const center = mapRef.getCenter();
        marker.setPosition(center);
      });

      return () => listener.remove();
    }
  }, [mapRef, marker]);

  const handleDragEnd = () => {
    if (mapRef) {
      const center = mapRef.getCenter();
      setPosicao({ lat: center.lat(), lng: center.lng() });
    }
  };
  
  const calcularDistancia = async () => {
    try{
      const destino = `${endereco?.rua}, ${endereco?.numero}, ${endereco?.bairro}, ${endereco?.cidade} - ${endereco?.uf}`;
      const response = await get(`/gvendas/empresas/${empresa?.id}/calcular-taxa-de-entrega/?endereco=${destino}`);
      if(response && response.length){
        const result = response[0];
        setDistancia(result.distancia);
        setDuracao(result.duracao);
        setEndereco((prevItem)=>({
          ...prevItem,
          taxa:result.entrega_padrao,
          duracao:result.duracao
        }));
        setDisponivel(true);
      }
    }catch(err){
      //alert(JSON.stringify(err.response))
      if (err.response?.data?.detail){
        setDisponivel(false);
        alert(JSON.stringify(err.response?.data?.detail))
      } 
    }
  };

  useEffect(() => {
    const buscarSacola = async () => {
      try {
        const response = await storage.buscar('sacola');
        if (response && response.length) {
          const sacola = response[0] || {};
          setEndereco(sacola.endereco);
          setPosicao(sacola.endereco?.posicao);
          if(!sacola.endereco?.posicao){
            buscarEnderecoGPS();
          }
        }
      } catch (err) {
        console.error('Erro ao buscar sacola:', err);
      }
    };
    buscarSacola();
  }, [setEndereco]);

  const salvarEndereco = async () => {
    try {
      const response = await storage.buscar('sacola');
      if (response && response.length) {
        const sacola = {
          ...response[0],
          endereco: endereco
        };
        await storage.remover('sacola');
        await storage.adicionar('sacola', sacola);
        navigate(-1);
      }
    } catch (err) {
      console.error('Erro ao salvar endereço:', err);
    }
  };

  useEffect(() => {
    if (posicao && endereco?.is_entrega){
      buscarEnderecoCompleto();
    }
    setEndereco((prevItem)=>({
        ...prevItem,
        posicao:prevItem?.is_entrega?posicao:null
    }))
  }, [posicao, endereco?.is_entrega]);

  const buscarEnderecoCompleto = async () => {
    try {
      if (posicao) {
        const apiKey = 'AIzaSyAg-c1FKLHKp4mWCvI_t8POfLXWQtQbix0';
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${posicao?.lat},${posicao?.lng}&key=${apiKey}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data.results && data.results.length > 0 && endereco?.is_entrega) {
          const addressComponents = data.results[0].address_components;
          const street = addressComponents.find(component => component.types.includes("route"))?.long_name || '';
          const number = addressComponents.find(component => component.types.includes("street_number"))?.long_name || '';
          const neighborhood = addressComponents.find(component => component.types.includes("sublocality_level_1"))?.long_name ||
            addressComponents.find(component => component.types.includes("sublocality"))?.long_name ||
            addressComponents.find(component => component.types.includes("political"))?.long_name || '';
          const cidade = addressComponents.find(component => component.types.includes("administrative_area_level_2"))?.long_name ||
            addressComponents.find(component => component.types.includes("political"))?.long_name || '';
          const estadoUf = addressComponents.find(component => component.types.includes("administrative_area_level_1"))?.short_name ||
            addressComponents.find(component => component.types.includes("political"))?.short_name || '';

          setEndereco((prevItem) => ({
            ...prevItem,
            rua: `${street}`,
            numero: `${number}`,
            bairro: `${neighborhood}`,
            cidade: `${cidade}`,
            uf: `${estadoUf}`
          }));
          calcularDistancia();
        }
      }
    } catch (err) {
      console.error('Erro ao buscar endereço:', err);
    }
  };

  const buscarEnderecoGPS = async () => {
    try {
      const status = await navigator.permissions.query({ name: 'geolocation' });
  
      if (status.state === 'denied') {
        alert('Permissão de localização foi negada. Ative a localização nas configurações do navegador para continuar.');
        return;
      }
      
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const { latitude, longitude } = position.coords;
            setPosicao({ lat: latitude, lng: longitude });
          },
          (error) => {
            console.error(error);
          }
        );
      }
    } catch (err) {
      console.error('Erro ao buscar endereço:', err);
    }
  };

  useEffect(() => {
    if(!posicao && endereco?.is_entrega) buscarEnderecoGPS();
  }, [endereco?.is_entrega]);

  return (
    <div style={{ paddingBottom: '200px' }}>
      <div className="bs-floating shadow navbar-light">
        <div className="container py-2">
          <Button variant="secondary" onClick={salvarEndereco} disabled={!endereco || !disponivel} className="w-100 btn-lg">
            Confirmar
          </Button>
        </div>
      </div>

      <Row className="mb-4">
        <Col xs="auto" className="mx-auto">
          <InputGroup>
            <Button variant={`${endereco?.is_entrega ? '' : 'outline-'}secondary`} onClick={() => setEndereco((prevItem) => ({ ...prevItem, is_entrega: true }))} className="px-4">
              <i className="fa-solid fa-person-biking pe-2"></i>
              Entrega
            </Button>
            <Button variant={`${endereco?.is_entrega ? 'outline-' : ''}secondary`} onClick={() => setEndereco((prevItem) => ({ ...prevItem, is_entrega: false }))} className="px-4">
              <i className="bi bi-person-walking pe-2"></i>
              Retirada
            </Button>
          </InputGroup>
        </Col>
      </Row>

      {endereco?.is_entrega ? (
        <>
          {posicao && (
            <LoadScriptNext googleMapsApiKey="AIzaSyAg-c1FKLHKp4mWCvI_t8POfLXWQtQbix0">
              <GoogleMap
                mapContainerStyle={containerStyle}
                center={posicao}
                zoom={17}
                onLoad={(map) => setMapRef(map)}
                onDragEnd={handleDragEnd}
                options={{
                  minZoom: 17,
                  maxZoom: 17,
                  mapTypeId: 'roadmap'
                }}
              />
              {disponivel && (
                <div style={{ padding: '10px' }}>
                  Distância: {distancia}<br />
                  Entrega: {endereco?.duracao}<br />
                  Entrega padrão: {parseFloat(endereco?.taxa||0)<=0?"Grátis":parseFloat(endereco?.taxa||0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}<br />
                </div>
              )}
            </LoadScriptNext>
          )}

          <Form.Group controlId="formRua" className="mt-3">
            <InputGroup>
              <span className="input-group-text">Rua</span>
              <Form.Control
                type="text"
                value={endereco?.rua}
                onChange={(e) => setEndereco((prevItem) => ({ ...prevItem, rua: e.target.value }))}
              />
            </InputGroup>
          </Form.Group>

          <Form.Group controlId="formNumero" className="mt-3">
            <InputGroup>
              <span className="input-group-text">Número</span>
              <Form.Control
                type="number"
                value={endereco?.numero}
                onChange={(e) => setEndereco((prevItem) => ({ ...prevItem, numero: e.target.value }))}
              />
            </InputGroup>
          </Form.Group>

          <Form.Group controlId="formBairro" className="mt-3">
            <InputGroup>
              <span className="input-group-text">Bairro</span>
              <Form.Control
                type="text"
                value={endereco?.bairro}
                onChange={(e) => setEndereco((prevItem) => ({ ...prevItem, bairro: e.target.value }))}
              />
            </InputGroup>
          </Form.Group>

          <Form.Group controlId="formCidade" className="mt-3">
            <InputGroup>
              <span className="input-group-text">Cidade</span>
              <Form.Control
                type="text"
                value={endereco?.cidade}
                onChange={(e) => setEndereco((prevItem) => ({ ...prevItem, cidade: e.target.value }))}
              />
            </InputGroup>
          </Form.Group>

          <Form.Group controlId="formComplemento" className="mt-3">
            <InputGroup>
              <span className="input-group-text">Complemento</span>
              <Form.Control
                type="text"
                value={endereco?.complemento}
                onChange={(e) => setEndereco((prevItem) => ({ ...prevItem, complemento: e.target.value }))}
              />
            </InputGroup>
          </Form.Group>
        </>
      ) : (
        <div className="text-center mt-5 fs-5">

        </div>
      )}
    </div>
  );
};

export default Endereco;